import React, { useState } from "react";
import axios from "axios";
import { baseLogin, baseURL } from "../../Config/Config";
import Dropdawn from "../Dropdawn";
import userphoto from "../../assets/user.png";
import { Link, NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function Account() {
  const navigate = useNavigate();
  const [openProfile, setOpenProfile] = useState(false);
  const token = localStorage.getItem("access_token");
  const [data, setData] = useState();

  React.useEffect(() => {
    if (!token) return;
    axios
      .get(`${baseURL}user/user/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      })
      .then((response) => {
        setData(response.data);
        localStorage.setItem('user_data', JSON.stringify(response.data.user))
      })
      .catch((err) => {
        console.log(err.response);
        if (err.response && err.response.status === 401) {
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
        }
      });
  }, []);

  if (!data) return null;
  return (
    <div>
      <ul className="nav-menu ">
        {token ? (
          <li className="profil">
            <a href="#" onClick={() => setOpenProfile((prev) => !prev)}>
              <div className="profil-img">
                <img src={data.user.photo ? `https://rtr.profedu.uz${data.user.photo}` : userphoto} />
              </div>
              {data.user.last_name || data.user.first_name || data.user.username}
            </a>
            {openProfile && <Dropdawn />}
          </li>
        ) : (
          <li className="login-btn">
            <div className="button">
              <NavLink className="ruyxat" to="/signup">
                Ro‘yxatdan o‘tish
              </NavLink>
              <Link className="tizim" to="/signin">
                Tizimga krish
              </Link>
            </div>
          </li>
        )}
      </ul>
    </div>
  );
}

export default Account;
